exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "\n.width550[data-v-62c7f722] {\n  width: 550px;\n}\n.minHeight127[data-v-62c7f722] {\n  min-height: 127px;\n}\n.progressBar[data-v-62c7f722] {\n  height: 8px;\n  transition: all 300ms ease;\n}\n.taskCircle[data-v-62c7f722] {\n  width: 50px;\n  height: 50px;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"minimize":false,"sourceMap":false}!./node_modules/vue-loader/lib/style-compiler?{"id":"data-v-62c7f722","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js?{"sourceMap":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/dashboard/StratingTasks.vue
// module id = 2456
// module chunks = 0